import { render } from "./AccountPage.vue?vue&type=template&id=043e1a46&ts=true"
import script from "./AccountPage.vue?vue&type=script&lang=ts"
export * from "./AccountPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../var/local/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__